import { useEffect, useState } from "react";

export default function DeviceRestriction({ children }) {
  const [isAllowed, setIsAllowed] = useState(true);

  const allowAllDevices = process.env.REACT_APP_ALLOW_ALL_DEVICES === "true";

  useEffect(() => {
    if (allowAllDevices) {
      setIsAllowed(true);
      return;
    }

    const ua = navigator.userAgent || "";
    const platform = navigator.platform || "";
    const isTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;

    const MOBILE_REGEXES = [
      /(android|iphone|ipad|ipod|windows phone|iemobile|blackberry|bb10|webos|silk|kindle|playbook)/i,
      /(mobile|tablet|mobi|touch|crios|fxios|edga|edgios|ucbrowser|duckduckgo)/i,
      /(linux;\sandroid|iphone\sos|ios)/i,
    ];

    const uaMobile = MOBILE_REGEXES.some((re) => re.test(ua));

    const desktopPlatforms = /win32|macintel|linux x86_64/i.test(
      platform.toLowerCase()
    );

    const isMobileOrTablet = uaMobile || (isTouch && !desktopPlatforms);

    setIsAllowed(!isMobileOrTablet);
  }, [allowAllDevices]);

  if (!isAllowed) {
    return (
      <div
        style={{
          fontFamily:
            "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
          margin: 0,
          background: "#f78fa",
          color: "#1f2937",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          padding: "16px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            background: "#ffffff",
            padding: "40px 32px",
            borderRadius: "16px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
            textAlign: "center",
            maxWidth: "500px",
          }}
        >
          <h1 style={{ margin: "0 0 16px", fontSize: "28px", fontWeight: 600 }}>
            Mobile Access Restricted
          </h1>
          <p style={{ margin: "0 0 20px", color: "#6b7280", lineHeight: 1.6 }}>
            The Shree Sati 360 website is optimized exclusively for desktop
            environments.
          </p>
          <p style={{ margin: "0 0 20px", color: "#6b7280", lineHeight: 1.6 }}>
            For security, performance, and usability reasons, access from mobile
            devices and tablets is not permitted at this time.
          </p>
          <p style={{ margin: "0 0 20px", color: "#6b7280", lineHeight: 1.6 }}>
            Please use a desktop or laptop browser to continue.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
